export default class Category {
	constructor() {
		this.id = null;
		this.title = null;
    this.localeKey = null;
	}
}